import {Component, NgZone, OnInit} from '@angular/core';
import {PointOfSaleA2Service} from "../../core/point-of-sale.service.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NotificationService} from "../../root/toast/notification.service";
import {LoadingWheelService} from "../../root/loading/loading-wheel.service";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {AdditionalService} from "./additional.service";
import {Additional} from "./additional";
import {AdditionalPrice} from "./additional-price";
import {AdditionalValidationsService} from "./additional-validations.service";
import {ValidatorService} from "../../core/validator.service";
import {Observable} from "rxjs/Observable";
import {ModalService} from "../../root/modal/modal.service";
import {SessionService} from "../../core/session.service";
import {SidebarService} from "../../root/sidebar/sidebar.service";
import {AdditionalDto} from "./additional-dto";

@Component({
    selector: 'additional-edit',
    templateUrl: './additional-edit.component.html',
    providers: [PointOfSaleA2Service, AdditionalService, AdditionalValidationsService]
})
export class AdditionalEditComponent implements OnInit {

    id: any;
    companyOid: number;
    isEditing: boolean;

    additionalPrice: AdditionalPrice = new AdditionalPrice();
    errors: any = {};

    additionalSelected: AdditionalDto = new AdditionalDto();
    unlimitedToll: { addSelected: string, baseAmount: number, lane: boolean } = { addSelected: null, baseAmount: 0, lane: true };
    toll: AdditionalDto = new AdditionalDto('TOLL_CONS_PER_DAY', 0);
    showUnlimited: boolean = false;
    showLimited: boolean = false;
    posSelected: any = {};
    included:boolean=false;
    private posForm: any;
    private additionalForm: any;
    private unlimitedTollForm: any;
    private limitedTollForm: any;

    additionals: Additional[];
    pointsOfSale: any;
    notEnsuredAdditionals: Array<Additional>;
    ensuredAdditionals: Array<Additional>;
    tollConsList:Array<Additional>=[];
    tollUnlimited:Additional;

    endLoading:number=0;

    private static readonly MAX_TOLL_RATE: number = 20;

    private errorMessages = {
        'posSelected': 'common.error.REQUIRED',
        'baseAmount': 'warning.invalidNumberFormat',
        'tollSelection': 'additionalPrice.error.TOLL_SELECTION',
        'unlimitedTollBaseAmount': 'ERROR.toll.maxAmount',
        'limitedTollBaseAmount': 'ERROR.toll.maxAmount',
        'additionalSelection':'common.error.REQUIRED'
    }


    constructor(private  zone: NgZone, private additionalService: AdditionalService,
                private route: ActivatedRoute, private toast: NotificationService, private navigation: Router,
                private loading: LoadingWheelService, private _fb: FormBuilder, private validator:AdditionalValidationsService,
                private modalService:ModalService, private sessionService:SessionService, private sidebar: SidebarService,
                private notifications: NotificationService) {
        this.sidebar.sidebar = "generalConditions";
    }

    ngOnInit(): void {
        this.zone.run(() => {
            this.loading.show();
            this.route.params.subscribe(params => {
                this.companyOid = params['companyId'];
                this.id = params['id'];
                this.isEditing = this.id ? this.id != "add" : false;
                this.buildForm();
                this.endLoading++;
                this.additionalService.getData(this.companyOid).subscribe((response) => {
                    this.buildPosView(response[0]);
                    this.buildAddittionalsView(response[1]);
                    if (this.isEditing) {
                        this.endLoading++;
                        this.additionalService.loadAdditionalPrice(this.companyOid, this.id).subscribe((response) => {
                            this.buildAdditionalPriceOrTollView(response);
                            this.endLoading--;
                        });
                    }
                    this.endLoading--;
                });

            });
        });
    }
    private buildAdditionalPriceOrTollView(addPrice) {
        let additional = this.additionals.find((a) => a.oid == addPrice.additionalOid);
        this.posSelected[addPrice.posOid] = {checked:true};
        if (additional.code.startsWith("TOLL")) {
            this.buildTollView(addPrice, additional);
        }
        else {
            this.buildAdditionalView(addPrice, additional);
        }
    }

    public buildPosView(pointsOfSale){
        this.loading.hide();
        this.pointsOfSale = pointsOfSale;
        this.pointsOfSale.forEach((pos, index) => {
            this.posSelected[pos.oid] = {};
        });
    }

    private buildAddittionalsView(additionalsResult){
        this.additionals = [];
        this.notEnsuredAdditionals = [];
        this.ensuredAdditionals = [];
        this.tollConsList = [];
        this.additionals = additionalsResult;
        this.additionals.forEach((add, i) => {
            if (add.code == 'TOLL_UNLIMITED') {
                this.tollUnlimited = add;
            } else if (add.code.startsWith("TOLL_CONS")) {
                this.tollConsList.push(add)
            }
            else if (!add.ensureStock) {
                this.notEnsuredAdditionals.push(add);
            } else {
                this.ensuredAdditionals.push(add);
            }
        })
    }

    cleanTollConfiguration() {
        this.showUnlimited = false;
        this.showLimited = false;
        this.unlimitedToll = {addSelected: null, baseAmount: 0, lane: true};
        this.toll = {addSelected: 'TOLL_CONS_PER_DAY', baseAmount: 0};
    }

    getCountryCode(){
        if(!!this.sessionService.getUserSession()){
            return this.sessionService.getUserSession().countryOid;
        }
    }

    getCurrencyCode(){
        if(!!this.sessionService.getUserSession()){
            return this.sessionService.getUserSession().currencyCode;
        }
    }

    public buildTollView(addPrice, additional) {
        this.additionalSelected.addSelected = 'TOLL';
        if(additional.code == 'TOLL_UNLIMITED'){
            this.showUnlimited = true;
            this.unlimitedToll = {
                addSelected : additional.code,
                baseAmount : addPrice.baseAmount,
                lane: addPrice.includeExpressLanes
            }
        }else{
            this.showLimited = true;
            this.toll = {
                addSelected : additional.code,
                baseAmount : addPrice.baseAmount
            }
        }
    }

    cancel(){
        this.modalService.show("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION",
            () => this.navigation.navigateByUrl('/company/'+this.companyOid+'/additionalPrice'));
    }

    private buildAdditionalView(add, additional) {
        this.additionalSelected = {addSelected: additional.code, baseAmount: add.baseAmount};
        this.included=add.included;
    }

    private buildForm() {

        this.posForm = this._fb.group({
            posSelected: ['', this.validatePointsOfSale]
        });

        this.additionalForm = this._fb.group({
            code: ['', Validators.required],
            baseAmount: [null, Validators.compose([this.validatePositiveValue, Validators.required])]
        });

        this.unlimitedTollForm = this._fb.group({
            unlimitedTollCode: ['', Validators.required],
            lane: ['', Validators.required],
            unlimitedTollBaseAmount: ['', Validators.compose([this.validateLessOrEqualMaxToll, this.validatePositiveValue, Validators.required])]
        });

        this.limitedTollForm = this._fb.group({
            limitedTollCode: ['', Validators.required],
            limitedTollBaseAmount: ['', Validators.compose([this.validateLessOrEqualMaxToll, this.validatePositiveValue, Validators.required])],
        });
    }

    private validatePositiveValue(c:any) {
        return (!!c.value && ValidatorService.positiveValue({value: c.value.baseAmount})) || (!!c.value && c.value.baseAmount == 0 && (c.value.included)) ? null : {
            valid: false
        }
    }

    private validateLessOrEqualMaxToll(c:any) {
        return (!!c.value && ValidatorService.lessThanOrEqualTo({value: c.value.baseAmount}, AdditionalEditComponent.MAX_TOLL_RATE)) ? null : {valid : false};
    }

    private validatePointsOfSale(c: FormControl) {
        return !!c.value && Object.keys(c.value).some((k) => c.value[k].checked == true) ? null : {
            valid: false
        }
    }

    save() {
        this.bindValues();
        let validations = this.validator.validate(this.additionalSelected, this.showUnlimited, this.showLimited, this.unlimitedTollForm,
            this.limitedTollForm, this.additionalForm, this.posForm);

        if(validations.valid){
            if(this.additionalSelected.addSelected == 'TOLL'){
                this.additionalService.saveToll(this.buildToll(), this.companyOid, null).subscribe(
                    (response) => {this.persistCallback(this)},
                    (error) => {
                        if(error.status == 400){
                            let codes = JSON.parse(error._body);
                            this.notifications.notifyFrontErrorDetailByCodes(codes);
                        }else{
                            Observable.throw(error);
                            throw error;
                        }
                    }
                );
            }else{
                this.additionalService.saveAdditional(this.buildAdditional(), this.companyOid, null).subscribe(
                    (response) => {this.persistCallback(this)},
                    (error) => {
                        Observable.throw(error);
                        throw error;
                    }
                );
            }
            this.errors={};
        }else{
            this.errors = validations.errors;
        }
    }

    private persistCallback(context:any){
        context.toast.displayToast('additionalPrice.TITLE','additionalPrice.confirmationMessage.SUCCESS_SAVE', null, 'INFO');
        context.navigation.navigateByUrl('/company/'+context.companyOid+'/additionalPrice');
    }

    private bindValues() {
        this.additionalForm.controls['code'].setValue(this.additionalSelected.addSelected);
        this.additionalForm.controls['baseAmount'].setValue({baseAmount: this.additionalSelected.baseAmount, included:this.included});
        this.posForm.controls['posSelected'].setValue(this.posSelected);
        this.unlimitedTollForm.controls['unlimitedTollCode'].setValue(this.unlimitedToll.addSelected);
        this.unlimitedTollForm.controls['unlimitedTollBaseAmount'].setValue({baseAmount: this.unlimitedToll.baseAmount, included:this.included});
        this.unlimitedTollForm.controls['lane'].setValue(this.unlimitedToll.lane);
        this.limitedTollForm.controls['limitedTollCode'].setValue(this.toll.addSelected);
        this.limitedTollForm.controls['limitedTollBaseAmount'].setValue({baseAmount: this.toll.baseAmount});

    }

    includeUnlimitedToll(event): void {
        event.target.checked ? this.unlimitedToll.addSelected = this.tollUnlimited.code : '';
    }

    checkAll(checked) {
        for (let posOid in this.posSelected) {
            this.posSelected[posOid].checked = checked;
        }
    }

    // private invalidFormValidations(additional: any) {
    //     if (!!additional.controls) {
    //         Object.keys(additional.controls).forEach((key) => {
    //             this.invalidFormValidations(additional.controls[key]);
    //         })
    //         additional.setValidators(null);
    //     } else {
    //         additional.setValidators(null);
    //     }
    // }
    //
    // private updateFormValidations(additional: any) {
    //     if (!!additional.controls) {
    //         Object.keys(additional.controls).forEach((key) => {
    //             this.invalidFormValidations(additional.controls[key]);
    //         })
    //         additional.updateValueAndValidity();
    //     } else {
    //         additional.updateValueAndValidity();
    //     }
    // }

    public buildToll() {
        let tollPriceDto = {unlimited:null, perComsumption:null};
        let posOids = Object.keys(this.posSelected).map((obj) => {
            if(this.posSelected[obj].checked){return obj;}
        }).filter((pos) => !!pos);
        if(this.showLimited){
            tollPriceDto.perComsumption = this.buildPreConsumption();
            tollPriceDto.perComsumption.pointOfSales = posOids;
        }

        if(this.showUnlimited){
            tollPriceDto.unlimited= this.buildUnlimited();
            tollPriceDto.unlimited.pointOfSales = posOids;
        }
        return tollPriceDto;
    }

    public buildPreConsumption() {
        return {
            baseAmount:this.toll.baseAmount,
            additionalOid:this.additionals.find((a) => a.code == this.toll.addSelected).oid,
        }
    }

    public buildUnlimited() {
        return {
            baseAmount:this.unlimitedToll.baseAmount,
            additionalOid:this.additionals.find((a) => a.code == this.unlimitedToll.addSelected).oid,
            includeExpressLanes:this.unlimitedToll.lane
        }
    }

    public buildAdditional() {
        return {
            baseAmount:this.additionalSelected.baseAmount,
            oid:null,
            pointOfSales: Object.keys(this.posSelected).map((obj) => {
                if(this.posSelected[obj].checked){return obj;}
            }).filter((pos) => !!pos),
            additionalOid:this.additionals.find((a) => a.code == this.additionalSelected.addSelected).oid,
            included:this.included
        }
    }

    resetBaseAmount() {
        this.additionalSelected.baseAmount = 0;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/additional/additional-edit.component.ts